import React, { useState } from 'react'
import './ThemeToggle.css'
import {
  THEME_CONFIGS,
  applyTheme,
  getSavedTheme,
  saveTheme,
} from '../../utils/themeUtils'

const ThemeToggle = () => {
  const [currentTheme, setCurrentTheme] = useState(getSavedTheme)

  const handleThemeChange = (themeKey) => {
    setCurrentTheme(themeKey)
    applyTheme(themeKey)
    saveTheme(themeKey)
  }

  return (
    <div className="theme-toggle-container">
      <div className="theme-toggle-header">
        <h3>🎨 Theme Settings</h3>
        <p className="theme-toggle-subtitle">
          Choose your preferred color scheme
        </p>
      </div>

      <div className="theme-options">
        {Object.entries(THEME_CONFIGS).map(([key, config]) => (
          <button
            key={key}
            className={`theme-option ${currentTheme === key ? 'active' : ''}`}
            onClick={() => handleThemeChange(key)}
            data-testid={`theme-option-${key}`}
            aria-pressed={currentTheme === key}
          >
            <div className="theme-option-header">
              <div className="theme-option-radio">
                {currentTheme === key && <div className="radio-dot" />}
              </div>
              <div className="theme-option-info">
                <h4>{config.name}</h4>
                <p>{config.description}</p>
              </div>
            </div>
            <div className="theme-preview">
              <div
                className="preview-swatch"
                style={{ backgroundColor: config.colors['--fl-theme-primary'] }}
                title="Primary"
              />
              <div
                className="preview-swatch"
                style={{
                  backgroundColor: config.colors['--fl-theme-secondary'],
                }}
                title="Secondary"
              />
              <div
                className="preview-swatch"
                style={{ backgroundColor: config.colors['--fl-theme-surface'] }}
                title="Background"
              />
            </div>
          </button>
        ))}
      </div>

      <div className="theme-toggle-footer">
        <small>
          Theme preference is saved and will persist across sessions
        </small>
      </div>
    </div>
  )
}

export default ThemeToggle
